import {
  AgentSelectorMobileSettings,
  AgentSelectorSettings,
  LauncherLeadingIconGlyph,
} from '../../store/modules/merchant/types';

/** Skipify mint — desktop/multi launcher star & sparkle color. */
export const DEFAULT_AGENT_SELECTOR_STAR_COLOR = '#01EAD3';

/** Ella SDK MultiLauncher defaults */
export const DEFAULT_AGENT_SELECTOR: AgentSelectorSettings = {
  backgroundColor: '#00103A',
  showLeadingIcon: true,
  leadingIcon: 'sparkle',
  leadingIconColor: DEFAULT_AGENT_SELECTOR_STAR_COLOR,
  mobile: {
    backgroundColor: '#00103A',
    labelText: 'How can I help?',
    labelTextColor: '#FEFEFE',
    showLeadingIcon: true,
    leadingIcon: 'star',
    leadingIconColor: '#FEFEFE',
  },
};

const isLeadingIconGlyph = (value: unknown): value is LauncherLeadingIconGlyph =>
  value === 'sparkle' || value === 'star';

export const isAgentSelectorHexValid = (value: string): boolean => /^#[0-9A-Fa-f]{6}$/.test(value);

const resolveDesktopLeadingIconColor = (value?: string): string => {
  if (!value || !isAgentSelectorHexValid(value)) {
    return DEFAULT_AGENT_SELECTOR_STAR_COLOR;
  }
  return value;
};

/** Apply when loading from MMS or persisting — not while the user is typing. */
export const normalizeMobileLabelTextFromServer = (value: string | undefined | null): string => {
  if (value == null) {
    return DEFAULT_AGENT_SELECTOR.mobile.labelText;
  }
  const trimmed = value.trim();
  return trimmed || DEFAULT_AGENT_SELECTOR.mobile.labelText;
};

/** Trim for PATCH/create; rejects whitespace-only labels. */
export const mobileLabelTextForStorage = (value: string): string => {
  const trimmed = value.trim();
  return trimmed || DEFAULT_AGENT_SELECTOR.mobile.labelText;
};

export const toAgentSelector = (
  agentSelector?:
    | (Partial<Omit<AgentSelectorSettings, 'mobile'>> & {
        mobile?: Partial<AgentSelectorMobileSettings>;
      })
    | null,
): AgentSelectorSettings => ({
  backgroundColor: agentSelector?.backgroundColor ?? DEFAULT_AGENT_SELECTOR.backgroundColor,
  showLeadingIcon: agentSelector?.showLeadingIcon ?? DEFAULT_AGENT_SELECTOR.showLeadingIcon,
  leadingIcon: isLeadingIconGlyph(agentSelector?.leadingIcon)
    ? agentSelector.leadingIcon
    : DEFAULT_AGENT_SELECTOR.leadingIcon,
  leadingIconColor: resolveDesktopLeadingIconColor(agentSelector?.leadingIconColor),
  mobile: {
    backgroundColor:
      agentSelector?.mobile?.backgroundColor ?? DEFAULT_AGENT_SELECTOR.mobile.backgroundColor,
    labelText:
      agentSelector?.mobile?.labelText !== undefined && agentSelector?.mobile?.labelText !== null
        ? agentSelector.mobile.labelText
        : DEFAULT_AGENT_SELECTOR.mobile.labelText,
    labelTextColor:
      agentSelector?.mobile?.labelTextColor ?? DEFAULT_AGENT_SELECTOR.mobile.labelTextColor,
    showLeadingIcon:
      agentSelector?.mobile?.showLeadingIcon ?? DEFAULT_AGENT_SELECTOR.mobile.showLeadingIcon,
    leadingIcon: isLeadingIconGlyph(agentSelector?.mobile?.leadingIcon)
      ? agentSelector.mobile.leadingIcon
      : DEFAULT_AGENT_SELECTOR.mobile.leadingIcon,
    leadingIconColor:
      agentSelector?.mobile?.leadingIconColor ?? DEFAULT_AGENT_SELECTOR.mobile.leadingIconColor,
  },
});
